import React from 'react';
import { UploaderProvider, useModal } from '@europrocurement/flexy-components';
import { useSnackbar } from 'notistack';
import { useDocumentContext } from '../providers/DocumentContext';
import { useSelectedDossierContext } from '../providers/SelectedDossierContext';
import AdditionnalCollectionRequestForm from '../components/detail/AdditionnalCollectionRequestForm/AdditionnalCollectionRequestForm';
import useDossierPrescripteur from './useDossierPrescripteur';

const useAdditionnalCollectionRequest = () => {
    const { modalActions } = useModal();
    const { getRequiredMissingDocuments } = useDocumentContext();
    const { siblings, dossier } = useSelectedDossierContext();
    const { getPrescriber } = useDossierPrescripteur();
    const { enqueueSnackbar } = useSnackbar();

    const callAdditionnalCollectionRequestModal = async () => {
        if (!dossier.prescripteurId) {
            enqueueSnackbar('Prescripteur non trouvé', { variant: 'error' });
            return;
        }
        const prescriber = await getPrescriber(dossier.prescripteurId as number);
        if (!prescriber) {
            enqueueSnackbar('Prescripteur non trouvé', { variant: 'error' });
            return;
        }

        // Get all related dossier from collection
        modalActions.call(
            <UploaderProvider>
                <AdditionnalCollectionRequestForm
                    dossiers={siblings}
                    dossier={dossier}
                    missingDocs={getRequiredMissingDocuments()}
                    prescriber={prescriber}
                />
            </UploaderProvider>,
            false,
            true,
        );
    };
    return { callAdditionnalCollectionRequestModal };
};

export default useAdditionnalCollectionRequest;
